import React, { useMemo, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import experienceImg1 from '../assets/img/experience-img1.jpg';
import experienceImg2 from '../assets/img/experience-img2.jpg';
import experienceImg3 from '../assets/img/experience-img3.jpg';
import experienceImg4 from '../assets/img/experience-img4.jpg';
import experienceImg5 from '../assets/img/experience-img5.jpg';
import experienceImg6 from '../assets/img/experience-img6.jpg';
import experienceImg7 from '../assets/img/experience-img7.jpg';
import experienceImg8 from '../assets/img/experience-img8.jpg';
import experienceImg9 from '../assets/img/experience-img9.jpg';
import experienceImg10 from '../assets/img/experience-img10.jpg';
import experienceImg11 from '../assets/img/experience-img11.jpg';
import experienceImg12 from '../assets/img/experience-img12.jpg';
import experienceImg13 from '../assets/img/experience-img13.jpg';
import experienceImg14 from '../assets/img/experience-img14.jpg';
import experienceImg15 from '../assets/img/experience-img15.jpg';
import experienceImg16 from '../assets/img/experience-img16.jpg';
import experienceImg17 from '../assets/img/experience-img17.jpg';
import experienceImg18 from '../assets/img/experience-img18.jpg';
import experienceImg19 from '../assets/img/experience-img19.jpg';
import experienceImg20 from '../assets/img/experience-img20.jpg';
import experienceImg21 from '../assets/img/experience-img21.jpg';
import experienceImg22 from '../assets/img/experience-img22.jpg';
import experienceImg23 from '../assets/img/experience-img23.jpg';
import experienceImg24 from '../assets/img/experience-img24.jpg';
import experienceImg25 from '../assets/img/experience-img25.jpg';
import experienceImg26 from '../assets/img/experience-img26.jpg';
import experienceImg27 from '../assets/img/experience-img27.jpg';
import experienceImg28 from '../assets/img/experience-img28.jpg';
import experienceImg29 from '../assets/img/experience-img29.jpg';
import experienceImg30 from '../assets/img/experience-img30.jpg';
import experienceImg31 from '../assets/img/experience-img31.jpg';
import experienceImg32 from '../assets/img/experience-img32.jpg';
import experienceImg33 from '../assets/img/experience-img33.jpg';
import experienceImg34 from '../assets/img/experience-img34.jpg';
import experienceImg35 from '../assets/img/experience-img35.jpg';
import experienceImg36 from '../assets/img/experience-img36.jpg';
import experienceImg37 from '../assets/img/experience-img37.jpg';
import experienceImg38 from '../assets/img/experience-img38.jpg';
import experienceImg39 from '../assets/img/experience-img39.jpg';
import experienceImg40 from '../assets/img/experience-img40.jpg';
import experienceImg41 from '../assets/img/experience-img41.jpg';
import experienceImg42 from '../assets/img/experience-img42.jpg';
import experienceImg43 from '../assets/img/experience-img43.jpg';
import experienceImg44 from '../assets/img/experience-img44.jpg';
import experienceImg45 from '../assets/img/experience-img45.jpg';
import experienceImg46 from '../assets/img/experience-img46.jpg';
import experienceImg47 from '../assets/img/experience-img47.jpg';
import experienceImg48 from '../assets/img/experience-img48.jpg';
import experienceImg49 from '../assets/img/experience-img49.jpg';
import experienceImg50 from '../assets/img/experience-img50.jpg';
import experienceImg51 from '../assets/img/experience-img51.jpg';
import experienceImg52 from '../assets/img/experience-img52.jpg';
import experienceImg53 from '../assets/img/experience-img53.jpg';
import experienceImg54 from '../assets/img/experience-img54.jpg';
import experienceImg55 from '../assets/img/experience-img55.jpg';
import experienceImg56 from '../assets/img/experience-img56.jpg';
import experienceImg57 from '../assets/img/experience-img57.jpg';
import experienceImg58 from '../assets/img/experience-img58.jpg';
import experienceImg59 from '../assets/img/experience-img59.jpg';
import experienceImg60 from '../assets/img/experience-img60.jpg';
import experienceImg61 from '../assets/img/experience-img61.jpg';
import experienceImg62 from '../assets/img/experience-img62.jpg';
import experienceImg63 from '../assets/img/experience-img63.jpg';
import experienceImg64 from '../assets/img/experience-img64.jpg';
import experienceImg65 from '../assets/img/experience-img65.jpg';
import experienceImg66 from '../assets/img/experience-img66.jpg';
import experienceImg67 from '../assets/img/experience-img67.jpg';
import experienceImg68 from '../assets/img/experience-img68.jpg';
import experienceImg69 from '../assets/img/experience-img69.jpg';
import experienceImg70 from '../assets/img/experience-img70.jpg';
import experienceImg71 from '../assets/img/experience-img71.jpg';
import experienceImg72 from '../assets/img/experience-img72.jpg';
import experienceImg73 from '../assets/img/experience-img73.jpg';
import experienceImg74 from '../assets/img/experience-img74.jpg';
import experienceImg75 from '../assets/img/experience-img75.jpg';
import experienceImg76 from '../assets/img/experience-img76.jpg';
import experienceImg77 from '../assets/img/experience-img77.jpg';
import experienceImg78 from '../assets/img/experience-img78.jpg';
import experienceImg79 from '../assets/img/experience-img79.jpg';
import experienceImg80 from '../assets/img/experience-img80.jpg';
import experienceImg81 from '../assets/img/experience-img81.jpg';
import experienceImg82 from '../assets/img/experience-img82.jpg';
import experienceImg83 from '../assets/img/experience-img83.jpg';
import experienceImg84 from '../assets/img/experience-img84.jpg';
import experienceImg85 from '../assets/img/experience-img85.jpg';
import experienceImg86 from '../assets/img/experience-img86.jpg';

/**
 * @typedef {"Workshop"|"Tech Talk"|"Industrial Visit"|"Hackathon"|"Social"|"Leadership"|"Conference"|"Career Fair"|"Fitness"} ITSEventType
 */
/**
 * @typedef {Object} ITSEvent
 * @property {string} slug
 * @property {string} name
 * @property {string} month
 * @property {ITSEventType} type
 * @property {string|null} image
 * @property {string} description
 * @property {string} memory
 */

export const itsEventTypes = [
    "Workshop",
    "Tech Talk",
    "Industrial Visit",
    "Hackathon",
    "Social",
    "Leadership",
    "Conference",
    "Career Fair",
    "Fitness",
];

export const itsTypeColor = {
    Workshop: "bg-purple-500/15 text-purple-300 border-purple-500/30",
    "Tech Talk": "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
    "Industrial Visit": "bg-amber-500/15 text-amber-300 border-amber-500/30",
    Hackathon: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    Social: "bg-pink-500/15 text-pink-300 border-pink-500/30",
    Leadership: "bg-blue-500/15 text-blue-300 border-blue-500/30",
    Conference: "bg-teal-500/15 text-teal-300 border-teal-500/30",
    "Career Fair": "bg-orange-500/15 text-orange-300 border-orange-500/30",
    Fitness: "bg-lime-500/15 text-lime-300 border-lime-500/30",
};

const typeStyleMap = {
    Workshop: { backgroundColor: 'rgba(139, 92, 246, 0.16)', color: '#e5d5ff', border: '1px solid rgba(139, 92, 246, 0.35)' },
    'Tech Talk': { backgroundColor: 'rgba(56, 189, 248, 0.14)', color: '#c0f1ff', border: '1px solid rgba(56, 189, 248, 0.32)' },
    'Industrial Visit': { backgroundColor: 'rgba(245, 158, 11, 0.14)', color: '#ffe5a8', border: '1px solid rgba(245, 158, 11, 0.32)' },
    Hackathon: { backgroundColor: 'rgba(16, 185, 129, 0.14)', color: '#c7f7e0', border: '1px solid rgba(16, 185, 129, 0.32)' },
    Social: { backgroundColor: 'rgba(236, 72, 153, 0.14)', color: '#ffcee6', border: '1px solid rgba(236, 72, 153, 0.32)' },
    Leadership: { backgroundColor: 'rgba(59, 130, 246, 0.14)', color: '#d1e6ff', border: '1px solid rgba(59, 130, 246, 0.32)' },
    Conference: { backgroundColor: 'rgba(20, 184, 166, 0.14)', color: '#c9f7ef', border: '1px solid rgba(20, 184, 166, 0.32)' },
    'Career Fair': { backgroundColor: 'rgba(249, 115, 22, 0.14)', color: '#ffe4c2', border: '1px solid rgba(249, 115, 22, 0.32)' },
    Fitness: { backgroundColor: 'rgba(132, 204, 22, 0.14)', color: '#f4ffcf', border: '1px solid rgba(132, 204, 22, 0.32)' },
};

const experienceImages = [
    experienceImg1,
    experienceImg2,
    experienceImg3,
    experienceImg4,
    experienceImg5,
    experienceImg6,
    experienceImg7,
    experienceImg8,
    experienceImg9,
    experienceImg10,
    experienceImg11,
    experienceImg12,
    experienceImg13,
    experienceImg14,
    experienceImg15,
    experienceImg16,
    experienceImg17,
    experienceImg18,
    experienceImg19,
    experienceImg20,
    experienceImg21,
    experienceImg22,
    experienceImg23,
    experienceImg24,
    experienceImg25,
    experienceImg26,
    experienceImg27,
    experienceImg28,
    experienceImg29,
    experienceImg30,
    experienceImg31,
    experienceImg32,
    experienceImg33,
    experienceImg34,
    experienceImg35,
    experienceImg36,
    experienceImg37,
    experienceImg38,
    experienceImg39,
    experienceImg40,
    experienceImg41,
    experienceImg42,
    experienceImg43,
    experienceImg44,
    experienceImg45,
    experienceImg46,
    experienceImg47,
    experienceImg48,
    experienceImg49,
    experienceImg50,
    experienceImg51,
    experienceImg52,
    experienceImg53,
    experienceImg54,
    experienceImg55,
    experienceImg56,
    experienceImg57,
    experienceImg58,
    experienceImg59,
    experienceImg60,
    experienceImg61,
    experienceImg62,
    experienceImg63,
    experienceImg64,
    experienceImg65,
    experienceImg66,
    experienceImg67,
    experienceImg68,
    experienceImg69,
    experienceImg70,
    experienceImg71,
    experienceImg72,
    experienceImg73,
    experienceImg74,
    experienceImg75,
    experienceImg76,
    experienceImg77,
    experienceImg78,
    experienceImg79,
    experienceImg80,
    experienceImg81,
    experienceImg82,
    experienceImg83,
    experienceImg84,
    experienceImg85,
    experienceImg86,
];

const getEventYear = (month) => {
    const matches = month.match(/20\d{2}/g);
    if (!matches || matches.length === 0) return null;
    return Number(matches[matches.length - 1]);
};

const itsEventsBase = [
    {
        slug: "ytm-friendly-program", name: "Program with Yayasan Telekom Malaysia and Yayasan DiRaja Sultan Mizan Scholars", month: "November 2022", type: "Social", attendance: null,
        description: "Attended an official engagement ceremony at DoubleTree by Hilton Putrajaya Lakeside with five Terengganu scholars and key representatives from Yayasan Telekom Malaysia and Yayasan DiRaja Sultan Mizan under the Yayasan Telekom Malaysia Future Leaders Scholarship.",
        memory: "First official scholar engagement — the moment the scholarship felt like a real network, not just a letter."
    },
    {
        slug: "tm-museum-immersio", name: "Telekom Museum IMMERSIO Visit", month: "November 2022", type: "Industrial Visit", attendance: null,
        description: "Visited Telekom Malaysia Museum with fellow TM scholars, gaining exposure to Malaysia's telecommunications history and connecting with other scholarship recipients.",
        memory: "Walking through Malaysia's telco history alongside the people I'd grow with for years."
    },
    {
        slug: "mcf-christmas-2022", name: "MMU Christian Fellowship Society Christmas Party", month: "December 2022", type: "Social", attendance: null,
        description: "Joined the first university Christmas party, meeting a new group of people who later became meaningful connections throughout the university journey.",
        memory: "First uni Christmas party — didn't realize how many of these faces would stick around."
    },
    {
        slug: "quack-a-run-mmu", name: "Quack A Run MMU", month: "January 2023", type: "Fitness", attendance: null,
        description: "Joined first university running event with a solo 5KM morning run around MMU Cyberjaya Campus — marking the start of a casual fitness/running side quest.",
        memory: "First uni running event. The start of a quiet side quest that would keep showing up."
    },
    {
        slug: "bearmallow-charity", name: "Bearmallow MMU Charity Enterprise", month: "January 2023", type: "Leadership", attendance: null,
        description: "Directed a student-run enterprise for a business management subject. Initiated collaboration with 7 other small enterprises and successfully donated RM1,013.10 to UNICEF Malaysia.",
        memory: "The first time I directed something with a real outcome — RM1,013.10 to UNICEF. Small scale, but it felt meaningful."
    },
    {
        slug: "ytm-induction-camp", name: "Yayasan Telekom Malaysia Induction Camp", month: "March 2023", type: "Leadership", attendance: null,
        description: "Participated in a 4-day, 3-night scholars camp at Thistle Port Dickson Resort, involving talks, team-building activities, networking, and performance night.",
        memory: "Four days that turned scholar names into actual friendships."
    },
    {
        slug: "its-bonding-2023", name: "IT Society Bonding Session", month: "April 2023", type: "Social", attendance: null,
        description: "Joined the first physical bonding session with IT Society committee members, creating early connections with seniors and beginning deeper involvement in the council.",
        memory: "The first time ITS felt less like a club and more like a circle."
    },
    {
        slug: "mcf-melaka-trip", name: "MMU Christian Fellowship Society Cyberjaya to Melaka Trip", month: "April 2023", type: "Social", attendance: null,
        description: "Joined a one-day fellowship trip to MMU Melaka Campus, combining bonding with students from another campus and a short visit to Melaka landmarks such as A Famosa and Jonker Street.",
        memory: "A day trip that turned into one of the warmer memories of Year 1."
    },
    {
        slug: "csrw-apr-2023", name: "CSRW April 2023", month: "April 2023", type: "Social", attendance: null,
        description: "Took on the first Public Relations and Marketing role for IT Society — supporting booth setup, cleanup, student engagement, and club activity promotion.",
        memory: "First time running a booth for ITS — the start of the PR & Marketing track."
    },
    {
        slug: "monsta-chat-picnic", name: "Monsta Chat-in Picnic", month: "May 2023", type: "Social", attendance: null,
        description: "Attended a picnic-style networking session at Perdana Botanical Gardens with students from other universities and industry participants — sharing personal struggles, experiences, and growth perspectives.",
        memory: "An honest afternoon on the grass. One of those events you don't forget."
    },
    {
        slug: "tech-career-days-2023", name: "Tech Career Days 2023", month: "June 2023", type: "Career Fair", attendance: null,
        description: "Served as Head of Sponsorship Division, supporting sponsorship and partnership efforts for a student career-related event.",
        memory: "First Head of Sponsorship role. The start of a pattern that would repeat through 2023 and into 2024."
    },
    {
        slug: "stanchart-visit-2023", name: "Industrial Visit to Standard Chartered Malaysia", month: "June 2023", type: "Industrial Visit", attendance: null,
        description: "Joined the first industrial visit organized by IT Society Melaka Campus, gaining early exposure to corporate and financial industry environments.",
        memory: "First industrial visit — corporate banking floors at eye level."
    },
    {
        slug: "entice-2023", name: "ENTICE 2023 by MBOT", month: "August 2023", type: "Conference", attendance: null,
        description: "Represented IT Society MMU Cyberjaya at the Experts Network in Technology, Innovation and Cooperative Event — ESG, sustainability, climate change, technology innovation, and professional networking held at Hilton Hotel Kuala Lumpur.",
        memory: "One of the first times representing ITS at an external professional event. A preview of what was ahead."
    },
    {
        slug: "coffee-chat-mystartup", name: "Coffee Chat for Tech Students — MYStartup x Kabel", month: "August 2023", type: "Tech Talk", attendance: null,
        description: "Organized and attended a TechTalk in collaboration with IT Society Cyberjaya. Featured career sharing by Matija K. from Infobip and introduced the differences between UX and CX.",
        memory: "One of the first events I helped organize. The moment organizing something felt genuinely satisfying."
    },
    {
        slug: "csrw-aug-2023", name: "CSRW August 2023", month: "August 2023", type: "Social", attendance: null,
        description: "Supported IT Society during a busy recruitment period with a large freshman intake — promoting club activities as well as committee recruitment for CodeNection and BarCamp.",
        memory: "The CSRW that fed straight into CodeNection and BarCamp recruitment. Long days at the booth."
    },
    {
        slug: "chess-tournament-mpu", name: "MPU3427 Mini Chess Tournament", month: "September 2023", type: "Social", attendance: "40 players",
        description: "Served as Arbiter Organiser, Secretary, Arbiter, and Photographer for a mini chess tournament at MMU Cyberjaya. Involved 15 organizing committees and 40 players under Blitz chess rules.",
        memory: "Four roles in one event. Chaotic but a crash course in what event organizing actually demands."
    },
    {
        slug: "integrity-leadership-day", name: "Integrity and Leadership Day", month: "September 2023", type: "Social", attendance: "~912 students",
        description: "Worked with FCI Year 1 Trimester 1 coursemates to organize a large-scale event attended by around 912 students. Short preparation timeline, heavy teamwork.",
        memory: "912 students. My first taste of what a truly large-scale event feels like — and how much coordination it takes."
    },
    {
        slug: "mmu-future-leaders-2023", name: "MMU Future Leaders Programme 2023", month: "November 2023", type: "Leadership", attendance: null,
        description: "Represented IT Society Cyberjaya at a three-day leadership camp in Gemencheh, Negeri Sembilan — flying fox, kayaking, jungle trekking, leadership performances, and campfire night.",
        memory: "The camp that planted the seed for wanting to lead something bigger."
    },
    {
        slug: "csrw-nov-2023", name: "CSRW November 2023", month: "November 2023", type: "Social", attendance: null,
        description: "Wrapped up the year's club promotion cycle by sharing IT Society's event journey, achievements, and upcoming opportunities with students.",
        memory: "Closing out 2023's CSRW cycle — a whole year of booths in the rearview."
    },
    {
        slug: "barcamp-2023", name: "BarCamp Cyberjaya 2023", month: "December 2023", type: "Social", attendance: null,
        description: "Served as Head of Sponsorship Division for IT Society's annual unconference. Led a team of five, secured sponsorship support, and invited other MMU clubs to contribute.",
        memory: "First time leading a division. Learned that sponsorship means a lot of follow-up emails."
    },
    {
        slug: "mocc-2023", name: "Multimedia University Open Chess Championship 2023", month: "December 2023", type: "Social", attendance: "~200 participants",
        description: "Joined the MOCC 2023 committee and stepped up as Head of Sponsorship Division. Helped secure two sponsors for a non-FIDE rated chess tournament.",
        memory: "Back-to-back sponsorship roles in December. Became comfortable with the word 'no' very quickly."
    },
    {
        slug: "codenection-2023", name: "CodeNection 2023", month: "December 2023", type: "Hackathon", attendance: "646 students · 37 universities",
        description: "Served as Assistant Director for CodeNection 2023 — led 36 committee members across seven departments, secured sponsors and partners, supporting 646 students from 37 universities.",
        memory: "Assistant Director for CodeNection 2023. The year before the presidency. The year I realized I wanted it."
    },
    {
        slug: "mmu-awards-2023", name: "MMU Awards 2023", month: "February 2024", type: "Leadership", attendance: null,
        description: "Served under the Sponsorship Division for MMU's annual award ceremony, helping secure monetary and in-kind contributions for an event celebrating outstanding students, clubs, and societies that shaped campus life.",
        memory: "First Sponsorship Division role — the start of a track that would shape the next two years."
    },
    {
        slug: "mdec-tech-club-2024", name: "MDEC Premier Digital Tech Institution Tech Club Workshop 2024", month: "March 2024", type: "Workshop", attendance: null,
        description: "Attended the first external workshop as IT Society President, joining MDEC-recognized tech club leaders to exchange ideas and explore potential student tech initiatives for 2024.",
        memory: "First external workshop as president — sitting at a table of leaders from across the country."
    },
    {
        slug: "csrw-apr-2024", name: "CSRW April 2024", month: "April 2024", type: "Social", attendance: null,
        description: "IT Society participated in MMU's club showcase to introduce activities and opportunities to new students.",
        memory: "The first event of the term — setting the tone for what was ahead."
    },
    {
        slug: "president-appointed", name: "IT Society Annual General Meeting Term 2023/2024", month: "April 2024", type: "Leadership", attendance: null,
        description: "Officially took on the role of President of IT Society MMU Cyberjaya for the 2023/2024 term on 26 April 2024.",
        memory: "26 April 2024. The moment the responsibility became real."
    },
    {
        slug: "bonding-apr-2024", name: "IT Society Bonding Session", month: "April 2024", type: "Social", attendance: null,
        description: "Internal bonding session for newly appointed council members — teamwork, games, and planning.",
        memory: "Where the team started becoming a team."
    },
    {
        slug: "git-github-workshop", name: "Intro to Git & GitHub Workshop", month: "April 2024", type: "Workshop", attendance: null,
        description: "First workshop of the term — Git, GitHub, collaboration workflows, and project management basics.",
        memory: "First workshop as president. Nerve-wracking but it ran smoothly thanks to the team."
    },
    {
        slug: "blockchain-icp", name: "Blockchain with Internet Computer Malaysia", month: "May 2024", type: "Tech Talk", attendance: null,
        description: "Tech talk on blockchain technology, practical applications, and industry impact.",
        memory: "Opened up a whole new direction of tech students hadn't explored before."
    },
    {
        slug: "fci-deans-list-2024", name: "Faculty of Computing and Informatics Dean's List Ceremony", month: "May 2024", type: "Social", attendance: null,
        description: "Attended the first Dean's List Ceremony organized by FCI since joining MMU, marking a meaningful academic recognition milestone during the university journey.",
        memory: "The first formal academic recognition moment — a quiet but meaningful checkpoint."
    },
    {
        slug: "mmu-student-parliament", name: "MMU Student Parliament", month: "June 2024", type: "Leadership", attendance: null,
        description: "Participated in a student leadership platform where club and society leaders debated motions and raised campus-related matters to push toward better outcomes for the student community.",
        memory: "First time arguing motions on the floor — leadership outside the ITS bubble."
    },
    {
        slug: "huawei-visit-jun", name: "Huawei Malaysia Customer Solution Innovation Centre Visit", month: "June 2024", type: "Industrial Visit", attendance: null,
        description: "Explored company culture, IoT products, 5G technology, and Huawei's presence in Malaysia.",
        memory: "Industrial visit to Huawei Malaysia. The scale of their operations was impressive to see in person."
    },
    {
        slug: "outsystems-workshop", name: "OutSystems Low-Code Workshop", month: "June 2024", type: "Workshop", attendance: null,
        description: "Hands-on enterprise web application development using the OutSystems low-code platform.",
        memory: "Surprised by how much you can build without writing much code."
    },
    {
        slug: "rays-2024", name: "Rainforest Youth Summit 2024", month: "June 2024", type: "Conference", attendance: null,
        description: "Represented MMU at RAYS 2024 in Kuching, Sarawak — sustainability, biodiversity, youth advocacy, and cultural heritage.",
        memory: "Kuching was unexpectedly one of the highlights of the year."
    },
    {
        slug: "web3-bootcamp", name: "Web3 Bootcamp at APU", month: "August 2024", type: "Workshop", attendance: null,
        description: "Blockchain talks, mini-station games, ideathon, smart contracts, and Holochain exposure.",
        memory: "Chaotic in the best way — learned a lot in a very short time."
    },
    {
        slug: "huawei-day-emcee", name: "Huawei Day Talk — Emcee Role", month: "August 2024", type: "Tech Talk", attendance: "~150 attendees",
        description: "Served as emcee for Huawei Day Talk at MMU, hosting a session for students and lecturers.",
        memory: "Standing in front of 150 people with a mic — nothing quite prepares you for that."
    },
    {
        slug: "celcomdigi-visit", name: "CelcomDigi AI Experience Centre Visit", month: "August 2024", type: "Industrial Visit", attendance: null,
        description: "Explored real-world 5G and AI use cases at CelcomDigi AiX.",
        memory: "Seeing AI applied to actual telco infrastructure was eye-opening."
    },
    {
        slug: "measat-visit", name: "MEASAT Satellite Systems Visit", month: "August 2024", type: "Industrial Visit", attendance: null,
        description: "Learned about satellite communication, mission control operations, Starlink reseller role, and connectivity services.",
        memory: "A room full of people tracking satellites in real time. Surreal."
    },
    {
        slug: "bxo-leadership-camp", name: "B-XO Leadership Camp 2024", month: "August 2024", type: "Leadership", attendance: null,
        description: "Leadership camp in Negeri Sembilan — survival activities, teamwork challenges, networking with student leaders.",
        memory: "The kind of camp that shows you who you are under pressure."
    },
    {
        slug: "csrw-aug-2024", name: "CSRW August 2024", month: "August 2024", type: "Social", attendance: null,
        description: "IT Society promoted the society to students during club registration week.",
        memory: "Getting new faces excited about what ITS does."
    },
    {
        slug: "jumpstart-aug", name: "FCI JumpStart Orientation — August Intake", month: "August 2024", type: "Social", attendance: null,
        description: "Welcomed new FCI students through engagement activities, workshops, and alumni sharing.",
        memory: "Full-circle moment — being there in a prerecorded video welcoming freshies due to B-XO Leadership Camp."
    },
    {
        slug: "tsgn-visit", name: "TS Global Network Industrial Visit", month: "August 2024", type: "Industrial Visit", attendance: null,
        description: "Visited TSGN to understand satellite communications equipment, earth station infrastructure, and server room operations.",
        memory: "A side of tech infrastructure most students never get to see."
    },
    {
        slug: "cognizant-genai", name: "Gen AI & Prompt Engineering Workshop at Cognizant", month: "August 2024", type: "Workshop", attendance: null,
        description: "Prompt engineering, generative AI use cases, chain-of-thought prompting, and design thinking.",
        memory: "One of the most practically useful workshops of the year."
    },
    {
        slug: "national-robotics-2024", name: "National Robotics Competition 2024", month: "September 2024", type: "Leadership", attendance: null,
        description: "Volunteered as Event Secretariat and timekeeper for the primary school category, supporting judging sessions where students presented LEGO Mindstorms-based prototype ideas through storytelling.",
        memory: "Watching primary schoolers pitch LEGO robots was unexpectedly the highlight of the month."
    },
    {
        slug: "moneylion-techtalk", name: "MoneyLion TechTalk", month: "September 2024", type: "Tech Talk", attendance: null,
        description: "Covered Java optimization, thread pools, JMX monitoring, and Notion's database/API architecture.",
        memory: "Deep technical content — the kind of talk that made me want to level up."
    },
    {
        slug: "graduan-bootcamp", name: "Career BootCamp with GRADUAN", month: "September 2024", type: "Workshop", attendance: null,
        description: "Collaborated with GRADUAN to help students improve resume writing and employability skills.",
        memory: "Helping peers get career-ready felt more impactful than I expected."
    },
    {
        slug: "ethical-hacking-workshop", name: "Introduction to Ethical Hacking Workshop", month: "September 2024", type: "Workshop", attendance: null,
        description: "Web hacking basics, Kali Linux, and foundational ethical hacking concepts.",
        memory: "A completely different corner of tech — fascinating entry point."
    },
    {
        slug: "moneylion-visit", name: "Industrial Visit to MoneyLion Malaysia", month: "September 2024", type: "Industrial Visit", attendance: null,
        description: "Fintech operations, workplace culture, and innovation at MoneyLion Malaysia HQ.",
        memory: "The visit that made fintech feel like a real, exciting space to work in."
    },
    {
        slug: "barcamp-2024", name: "BarCamp Cyberjaya 2024", month: "September 2024", type: "Social", attendance: null,
        description: "IT Society's annual unconference where participants shared ideas, experiences, and professional journeys.",
        memory: "Every year BarCamp surprises me with how good the conversations get."
    },
    {
        slug: "mumtec-hackathon", name: "MUMTECH X Western Digital 36H Hackathon", month: "September 2024", type: "Hackathon", attendance: null,
        description: "First physical hackathon experience — 36-hour build co-hosted by MUMTECH and Western Digital.",
        memory: "The start of a hackathon journey that would keep growing."
    },
    {
        slug: "ethkl-2024", name: "ETHKL24", month: "October 2024", type: "Conference", attendance: null,
        description: "Volunteered for a day at one of Malaysia's major Ethereum and blockchain conferences held at Kuala Lumpur Convention Centre, gaining exposure to the Web3 and blockchain ecosystem.",
        memory: "First time inside KLCC for a Web3 conference — a different ecosystem entirely."
    },
    {
        slug: "alps-ai-leadership", name: "ALPS: AI Integration and Ethical Leadership", month: "October 2024", type: "Conference", attendance: null,
        description: "Leadership panel at MCMC HQ on human-centered AI, workforce transformation, digital leadership, and innovation.",
        memory: "Being in MCMC HQ discussing AI policy with industry leaders felt significant."
    },
    {
        slug: "github-field-day", name: "GitHub Field Day Malaysia 2024", month: "October 2024", type: "Conference", attendance: null,
        description: "Represented IT Society at Malaysia's first regional GitHub Field Day — community events, hackathons, startups, and tech clubs.",
        memory: "Meeting the Malaysian tech community in one room. Instantly felt like home."
    },
    {
        slug: "zte-nextgen-hackathon", name: "ZTE NextGen 5G Hackathon 2024", month: "October 2024", type: "Hackathon", attendance: null,
        description: "Supported the event as a photographer, documenting a hackathon focused on next-generation 5G innovation.",
        memory: "Behind the lens this time — a different way of being part of an event."
    },
    {
        slug: "asus-roadshow", name: "ASUS Campus Roadshow", month: "November 2024", type: "Social", attendance: null,
        description: "Collaborated on a campus roadshow showcasing the ASUS Vivobook S15 AI PC and AI computing demos.",
        memory: "Bringing cutting-edge hardware to campus always draws a crowd."
    },
    {
        slug: "jumpstart-oct", name: "FCI JumpStart Orientation — October Intake", month: "November 2024", type: "Social", attendance: null,
        description: "Orientation engagement session for new FCI students.",
        memory: "Every intake a new batch of faces who'll make their own uni stories."
    },
    {
        slug: "csrw-nov-2024", name: "CSRW November 2024", month: "November 2024", type: "Social", attendance: null,
        description: "IT Society joined the November club registration week to showcase activities and recruit students.",
        memory: "The third and final CSRW of the year — the team was a well-oiled machine by this point."
    },
    {
        slug: "codenection-2024", name: "CodeNection 2024", month: "Nov–Dec 2024", type: "Hackathon", attendance: "633 participants · 31 institutions",
        description: "National-level programming event organized under IT Society. Later won Best Tech & Innovation Programme at MMU Awards 2024.",
        memory: "The biggest event of the term — and the one that will be remembered for years."
    },
    {
        slug: "grab-visit", name: "Industrial Visit to Grab Malaysia", month: "December 2024", type: "Industrial Visit", attendance: null,
        description: "Exposure to Grab's operations, workplace culture, and technology innovation.",
        memory: "Ending the year with Grab — a fitting close to an incredible run of industrial visits."
    },
    {
        slug: "mmu-convocation-2024", name: "MMU Convocation 2024", month: "December 2024", type: "Social", attendance: null,
        description: "Volunteered under the florist division for three days, helping sell gifts and flowers to graduates from the Class of 2024.",
        memory: "Three days of bouquets, proud families, and a preview of what graduation feels like."
    },
    {
        slug: "mdec-tech-club-2025", name: "MDEC Premier Digital Tech Institution Tech Club Workshop 2025", month: "December 2024", type: "Workshop", attendance: null,
        description: "Attended the final MDEC tech club workshop before handing over the IT Society presidency, contributing ideas and discussing potential initiatives for the 2025 student tech community.",
        memory: "The last MDEC workshop as president — closing the loop on a year of external rooms."
    },
    {
        slug: "irc-2025", name: "International Regulatory Conference 2025", month: "January 2025", type: "Conference", attendance: null,
        description: "Represented FCI and IT Society at MCMC's IRC 2025 — regulatory innovation, quantum technology, digital transformation, and national tech policy.",
        memory: "One of the most formal and eye-opening events of the entire journey."
    },
    {
        slug: "jingle-mingle", name: "Jingle Mingle BBQ Party", month: "January 2025", type: "Social", attendance: null,
        description: "IT Society appreciation and celebration for council members, committees, and partners of the 2023/2024 term.",
        memory: "The party that closed the chapter — and the one I didn't want to end."
    },
    {
        slug: "its-wrapup", name: "IT Society Council Term 2023/2024 Wrap-Up", month: "Early 2025", type: "Leadership", attendance: null,
        description: "Reflected on a two-year IT Society journey — from joining as a member to leading as President, and helping organize 20+ impactful events.",
        memory: "Looking back at two years and realizing how much had actually happened."
    },
    {
        slug: "deriv-hackathon", name: "Deriv AI Hackathon", month: "February 2025", type: "Hackathon", attendance: null,
        description: "Built DerivZap — an AI fraud-prevention prototype using Flask, React, Deriv API, and AI tools. First physical hackathon at Deriv Malaysia HQ.",
        memory: "The hackathon that made me realize I genuinely love building under pressure."
    },
    {
        slug: "gdgkl-build-ai", name: "GDGKL Build with AI Cloud KL", month: "April 2025", type: "Conference", attendance: null,
        description: "First GDGKL event at Google Malaysia HQ — Gemini, Google Cloud, AI Studio, Vertex AI, and NotebookLM.",
        memory: "Walking into Google Malaysia HQ for the first time. The kind of moment that makes you pause and take it all in."
    },
    {
        slug: "hackathon-umhack", name: "UMHackathon 2025", month: "April 2025", type: "Hackathon", attendance: null,
        description: "Part of the expanding hackathon portfolio — university-level competition.",
        memory: "A step up in competition level and a bigger team dynamic to navigate."
    },
    {
        slug: "huawei-sales-challenge", name: "Huawei Sales Elite Challenge 2025", month: "May 2025", type: "Leadership", attendance: null,
        description: "Top 50 finalist and Top 5 team in a national sales pitching challenge involving Huawei solar, photovoltaic, and ESS solutions.",
        memory: "Pitching to a panel of Huawei executives — a completely different kind of pressure."
    },
    {
        slug: "mmu-awards-codenection", name: "MMU Awards 2024 — CodeNection Recognition", month: "May 2025", type: "Leadership", attendance: "633 participants",
        description: "CodeNection 2024 won Best Tech & Innovation Programme at MMU Awards 2024 after nearly 10 years, with participants from 31 institutions.",
        memory: "The moment the work felt fully recognized. A genuinely proud moment."
    },
    {
        slug: "program-akar", name: "Program AKAR Cohort 2 — PayNet", month: "Mid 2025", type: "Workshop", attendance: null,
        description: "PayNet's career readiness programme covering AI in financial services, digital payments, Azure AI Fundamentals, Python for AI, values-based leadership, and an ideathon.",
        memory: "The programme that made fintech and AI feel deeply connected to real national infrastructure."
    },
    {
        slug: "gcp-boleh-s7", name: "GCP Boleh Season 7", month: "Mid–Late 2025", type: "Workshop", attendance: null,
        description: "Completed GCPBoleh Season 7 — earned 15 Google Cloud badges, completed 60+ labs across Vertex AI, Gemini, BigQuery, Document AI, and cloud-based AI/data workflows.",
        memory: "60+ labs later, Google Cloud stopped feeling like a black box."
    },
    {
        slug: "internship-core-consulting", name: "Internship at Core Consulting and Innovation", month: "July 2025 – October 2025", type: "Leadership", attendance: null,
        description: "17-week AIOps internship under the Digital Strategy Pillar — transforming operational data into live dashboard metrics and actionable insights using Dynatrace-related analytics.",
        memory: "The internship that showed me what real-world data work actually looks like."
    },
    {
        slug: "mbot-tech-on-track", name: "MBOT Tech on Track Fun Run", month: "September 2025", type: "Fitness", attendance: null,
        description: "Completed a solo early-morning run around Kuala Lumpur city — combining tech-community exposure with a personal fitness milestone.",
        memory: "An early KL morning, empty streets, and a quiet sense of momentum."
    },
    {
        slug: "aws-community-day", name: "AWS Community Day Malaysia 2025", month: "September 2025", type: "Conference", attendance: null,
        description: "First AWS Community event at Sunway University — MCP with Claude, SageMaker AI/MLOps, Kiro, DynamoDB, and Amazon Nova Act.",
        memory: "First AWS community event. The MCP with Claude session hit differently given what I was already building."
    },
    {
        slug: "lazada-fun-run", name: "Lazada Fun Run Malaysia", month: "October 2025", type: "Fitness", attendance: null,
        description: "Joined a Cyberjaya city morning run with a friend — continuing the running streak while making the experience more social and memorable.",
        memory: "Cyberjaya at sunrise hits different when you're running through it with a buddy."
    },
    {
        slug: "hackathon-umpsa", name: "UMPSA Hackathon", month: "October 2025", type: "Hackathon", attendance: null,
        description: "Inter-university hackathon as part of the continued hackathon journey.",
        memory: "Hackathon which expose me to Huawei Mobile Services (HMS) and teaches something new about building fast under constraints."
    },
    {
        slug: "hackathon-cimb-microsoft", name: "CIMB x Microsoft GenAI Hackathon", month: "November 2025", type: "Hackathon", attendance: null,
        description: "Industry-backed generative AI hackathon co-hosted by CIMB and Microsoft.",
        memory: "Combining fintech with GenAI in a competition format — right in the middle of everything I care about."
    },
    {
        slug: "datai-sig", name: "DATAI Student Interest Group", month: "November 2025 – June 2026", type: "Leadership", attendance: null,
        description: "Contributed to DATAI's skills development team — sharing internship experience and facilitating workshops.",
        memory: "Growing in a community I learned so much from."
    },
    {
        slug: "devfest-kl-2025", name: "DevFest Kuala Lumpur 2025", month: "December 2025", type: "Conference", attendance: null,
        description: "Attended Day 1 at APU — Google ADK, AI image manipulation safety, Hugging Face AI Sheets, and modern cloud security tools.",
        memory: "Ending 2025 at a developer festival felt like the right kind of full circle."
    },
    {
        slug: "hackathon-um-datathon", name: "UM Datathon 2025", month: "December 2025", type: "Hackathon", attendance: null,
        description: "Data-focused competition organized by University Malaya Data Analytics Club.",
        memory: "Where data storytelling under time pressure became a real skill."
    },
    {
        slug: "petronas-energizing-youth", name: "Energizing Youth Programme by PETRONAS", month: "February 2026", type: "Leadership", attendance: null,
        description: "Selected as one of 80 participants from GLUs for a three-week energy transition programme — Malaysia's gas sector, PETRONAS operations, LNG, sustainability, and Net Zero goals.",
        memory: "Being selected out of university-linked units for a PETRONAS programme was not on the bingo card."
    },
    {
        slug: "decathlon-ioi-fun-run", name: "Decathlon IOI City Mall Fun Run", month: "April 2026", type: "Fitness", attendance: null,
        description: "Took part in a morning fun run around IOI City Mall with a friend — adding a more social element to the running journey.",
        memory: "Running with a friend made the route feel half the distance."
    },
    {
        slug: "huawei-ai-lab-launch", name: "Huawei AI Lab and Innovation Centre Launch", month: "April 2026", type: "Industrial Visit", attendance: null,
        description: "Represented the university at the launch of Huawei's first AI-enabled industrial incubation base in Malaysia at The Exchange 106, TRX — focused on digital and energy transformation, industry-academia collaboration, innovation ecosystem development, and Malaysian AI talent training.",
        memory: "Standing inside TRX for the launch of Huawei's first AI incubation base in Malaysia. Surreal."
    },
    {
        slug: "hackathon-gdgkl-myhack", name: "GDG KL MyHack 2026", month: "May 2026", type: "Hackathon", attendance: null,
        description: "GDG Kuala Lumpur's MyHack event — part of the 2026 hackathon season.",
        memory: "The Google developer community hackathon that brought everything together."
    },
    {
        slug: "hackathon-vibeathon", name: "Vibeathon KL 2026", month: "May 2026", type: "Hackathon", attendance: null,
        description: "Competed at AWS Kuala Lumpur in an AI healthcare hackathon, building NadiCare — an AI-powered stroke care companion supporting patients through recovery, health monitoring, appointment management, and personalized care. As first-time Lovable users, the team transformed an idea into a working prototype within the competition duration.",
        memory: "Top 3 Finalist. First time using Lovable — ended up building something real enough to place. NadiCare was the kind of idea that actually mattered."
    },
    {
        slug: "inventx-2026", name: "iNVENTX 2026", month: "July 2026", type: "Conference", attendance: null,
        description: "Participated in MMU's flagship international innovation and invention showcase, presenting two final year project prototypes — PAWPAL and ARTEMO — through a public exhibition booth. Together with a teammate and supervisor, the team was awarded two Gold Awards.",
        memory: "Two Gold Awards. First major competition victory after years of perseverance. The last entry in the undergraduate chapter and the best way it could have ended."
    },
];

export const itsEvents = itsEventsBase.map((event, index) => ({
    ...event,
    image: experienceImages[index % experienceImages.length],
}));

export const eventYears = Array.from(
    new Set(itsEvents.flatMap((event) => {
        const year = getEventYear(event.month);
        return year ? [year] : [];
    }))
).sort((a, b) => b - a);

export const filterEvents = (selectedYear, selectedType) => {
    return itsEvents.filter((event) => {
        const year = getEventYear(event.month);
        const yearMatch = selectedYear === 'All' || selectedYear === year;
        const typeMatch = selectedType === 'All' || event.type === selectedType;
        return yearMatch && typeMatch;
    });
};

const ExperienceCard = ({ event }) => {
    const badgeStyle = typeStyleMap[event.type] || { backgroundColor: 'rgba(255,255,255,0.08)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)' };

    return (
        <div className="experience-card">
            <div className="experience-card-image" aria-hidden={!event.image}>
                {event.image ? (
                    <img src={event.image} alt={event.name} />
                ) : (
                    <div className="experience-image-placeholder">Image</div>
                )}
            </div>
            <div className="experience-card-body">
                <div className="experience-tag" style={badgeStyle}>{event.type}</div>
                <h4>{event.name}</h4>
                <p className="experience-month">{event.month}</p>
                <p className="experience-description">{event.description}</p>
                <p className="experience-memory"><strong>Highlights:</strong> {event.memory}</p>
            </div>
        </div>
    );
};

export const Experiences = () => {
    const [selectedYear, setSelectedYear] = useState('All');
    const [selectedType, setSelectedType] = useState('All');

    const filteredEvents = useMemo(
        () => filterEvents(selectedYear, selectedType),
        [selectedYear, selectedType]
    );

    return (
        <div className="experience-list-container">
            <div className="experience-filter-row">
                <div className="experience-filter-group">
                    <p className="experience-filter-label">Year</p>
                    <div className="experience-pill-row">
                        <button
                            type="button"
                            className={`experience-pill ${selectedYear === 'All' ? 'active' : ''}`}
                            onClick={() => setSelectedYear('All')}
                        >
                            All
                        </button>
                        {eventYears.map((year) => (
                            <button
                                key={year}
                                type="button"
                                className={`experience-pill ${selectedYear === year ? 'active' : ''}`}
                                onClick={() => setSelectedYear(year)}
                            >
                                {year}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="experience-filter-group">
                    <p className="experience-filter-label">Type</p>
                    <div className="experience-pill-row">
                        <button
                            type="button"
                            className={`experience-pill ${selectedType === 'All' ? 'active' : ''}`}
                            onClick={() => setSelectedType('All')}
                        >
                            All
                        </button>
                        {itsEventTypes.map((type) => (
                            <button
                                key={type}
                                type="button"
                                className={`experience-pill ${selectedType === type ? 'active' : ''}`}
                                onClick={() => setSelectedType(type)}
                            >
                                {type}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            <Row>
                {filteredEvents.map((event) => (
                    <Col xs={12} key={event.slug}>
                        <ExperienceCard event={event} />
                    </Col>
                ))}
            </Row>
        </div>
    );
};
